import { SyncthingFolder } from '../types';

export enum DeviceStatusEnum {
  ORDERED = 'ORDERED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  ERROR = 'ERROR',
}

export type Location = {
  id: number;
  latitude: number;
  longitude: number;
  created_at: string;
};

export type Device = {
  id: number;
  playwall_id: string;
  hardware_id: string;
  syncthing_id: string;
  status: DeviceStatusEnum;
  created_at: string;
  updated_at: string;
};

export type DeviceDetails = {
  id: number;
  playwall_id: string;
  hardware_id: string;
  syncthing_id: string;
  status: DeviceStatusEnum;
  created_at: string;
  updated_at: string;
  syncthing_folder: SyncthingFolder | null;
  latest_location: Location | null;
};

export type AddDeviceRequest = {
  playwall_id: string;
  hardware_id: string;
  syncthing_id: string;
  syncthing_name: string;
};
